import React from "react"
import { Link } from "react-router-dom"
import { TicketPerforated } from "react-bootstrap-icons"

export const ManageTicketsButton = ({ postId, color = "blue" }) => {
  return (
    <Link
      className="text-sm focus:outline-none"
      to={`/manage-tickets/${postId}`}
    >
      <TicketPerforated size={11} className="inline align-baseline mx-1" />
      Manage
    </Link>
  )
}

export default ManageTicketsButton
